import React, { useState } from "react";
import AppContainer from "../../../components/AppContainer";
import { Grid, MenuItem, Stack, Typography } from "@mui/material";
import ImageUploader from "../../../components/ImageUploader";
import Label from "../../../components/Label";
import TextInput from "../../../components/TextInputs";
import globalStyle from "../../../globalStyle";
import { allIcons } from "../../../assets";
import CustomDropDown from "../../../components/CutomDropDown";
import AddImages from "./AddImages";

const Results = ["FSLC", "Common", "etc"];

const EducationDetail = () => {
  const [allImages, setAllImages] = useState([]);
  return (
    <AppContainer
      primaryHeading={"School Details"}
      secondaryHeading={"View, edit and de-activate your account details."}
    >
      <Typography variant="h1" fontWeight={600} fontSize={"1.125rem"} mb={2}>
        General Details
      </Typography>
      <Grid container spacing={2} alignItems={"center"}>
        <Grid item xs={12} md={2.5}>
          <ImageUploader avatarSize={120} />
        </Grid>
        <Grid item xs={12} md={9.5}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Label labelText="Owner Name" />
              <TextInput
                styleProps={globalStyle.textField}
                placeholder={"Enter owner name"}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Label labelText="School Name" />
              <TextInput
                styleProps={globalStyle.textField}
                placeholder={"Enter school name"}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Label labelText="Email" />
              <TextInput
                styleProps={globalStyle.textField}
                placeholder={"Enter your email"}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Label labelText="Contact number" htmlFor={"email"} required />
              <TextInput
                styleProps={globalStyle.textField}
                placeholder={"Enter contact number"}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Typography
        variant="h1"
        fontWeight={600}
        fontSize={"1.125rem"}
        mt={3}
        mb={2}
      >
        School Details
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Label labelText="School phone number" />
          <TextInput
            styleProps={globalStyle.textField}
            placeholder={"Enter phone number"}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Label labelText="School Email" />
          <TextInput
            styleProps={globalStyle.textField}
            placeholder={"Enter school email"}
          />
        </Grid>
        <Grid item xs={12}>
          <Stack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Label labelText="Location" required />
            <Stack
              gap={1}
              direction={"row"}
              alignItems={"center"}
              sx={{ cursor: "pointer" }}
            >
              <Label labelText="Current" />
              <img
                src={allIcons.locationIcon}
                width={20}
                style={{ marginBottom: "5px" }}
              />
            </Stack>
          </Stack>
          <TextInput
            styleProps={globalStyle.textField}
            placeholder={"Enter full address"}
          />
        </Grid>
        <Grid item xs={12}>
          <Label labelText="Vision of School/College/University" />
          <TextInput
            styleProps={globalStyle.textField}
            placeholder={"Enter school email"}
            multiline
            rows={3}
          />
        </Grid>
      </Grid>

      <AddImages allImages={allImages} setAllImages={setAllImages} />

      <Typography
        variant="h1"
        fontWeight={600}
        fontSize={"1.125rem"}
        mt={3}
        mb={2}
      >
        Public Results
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <Label labelText="Select resutlt for" required />
          <CustomDropDown>
            {Results.map((val, index) => {
              return (
                <MenuItem key={index} value={val}>
                  {val}
                </MenuItem>
              );
            })}
          </CustomDropDown>
        </Grid>
        <Grid item xs={3}>
          <Label labelText="Total exam" required />
          <TextInput
            styleProps={globalStyle.textField}
            placeholder={"Total Exams"}
          />
        </Grid>
        <Grid item xs={3}>
          <Label labelText="Total pass" required />
          <TextInput
            styleProps={globalStyle.textField}
            placeholder={"Total pass"}
          />
        </Grid>
        <Grid item xs={3}>
          <Label labelText="Total percentage" required />
          <TextInput
            styleProps={globalStyle.textField}
            placeholder={"Total percentage"}
          />
        </Grid>
      </Grid>

      <Typography
        variant="h1"
        fontWeight={600}
        fontSize={"1.125rem"}
        mt={3}
        mb={2}
      >
        Terms and Conditions
      </Typography>

      <Grid container>
        <Grid item xs={12}>
          <Label labelText="Instruction" />
          <TextInput
            styleProps={globalStyle.textField}
            placeholder={"Enter terms and condition"}
            multiline
            rows={3}
          />
        </Grid>
      </Grid>

      <Grid container mt={3} spacing={2}>
        <Grid item xs={12} md={6}>
          <Typography
            variant="h1"
            fontWeight={600}
            fontSize={"1.125rem"}
            mb={1}
          >
            Facebook Page Link
          </Typography>
          <Label labelText="Link" required />
          <TextInput
            styleProps={globalStyle.textField}
            placeholder={"Enter facebook page link"}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography
            variant="h1"
            fontWeight={600}
            fontSize={"1.125rem"}
            mb={1}
          >
            Instagram Link
          </Typography>
          <Label labelText="Link" required />
          <TextInput
            styleProps={globalStyle.textField}
            placeholder={"Enter Instagram page link"}
          />
        </Grid>
      </Grid>
    </AppContainer>
  );
};

export default EducationDetail;
